import PropTypes from 'prop-types';
import React from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

import { theme } from '../../constants';

const breakpoints = [
  `${theme.BreakpointMobile}px`,
  `${theme.BreakpointMobileXl}px`,
  `${theme.BreakpointTablet}px`,
  `${theme.BreakpointTabletXl}px`,
  `${theme.BreakpointLaptop}px`,
  `${theme.BreakpointLaptopXl}px`,
  `${theme.BreakpointDesktop}px`,
  `${theme.BreakpointDesktopXl}px`,
  `${theme.BreakpointTv}px`,
];

breakpoints.mobile = `${theme.BreakpointMobile}px`;
breakpoints.tablet = `${theme.BreakpointTablet}px`;
breakpoints.laptop = `${theme.BreakpointLaptop}px`;
breakpoints.desktop = `${theme.BreakpointDesktop}px`;
breakpoints.tv = `${theme.BreakpointTv}px`;

const lightColors = {
  bg100: theme.ColorLightBg100,
  bg80: theme.ColorLightBg80,
  bg60: theme.ColorLightBg60,
  bg40: theme.ColorLightBg40,
  bg20: theme.ColorLightBg20,
  black100: theme.ColorLightBlack100,
  black80: theme.ColorLightBlack80,
  black60: theme.ColorLightBlack60,
  contrast100: theme.ColorLightContrast100,
  contrast80: theme.ColorLightContrast80,
  contrast60: theme.ColorLightContrast60,
  contrast40: theme.ColorLightContrast40,
  contrast20: theme.ColorLightContrast20,
  error: theme.ColorLightError,
  info: theme.ColorLightInfo,
  primary: theme.ColorLightPrimary,
  secondary: theme.ColorLightSecondary,
  success: theme.ColorLightSuccess,
  warning: theme.ColorLightWarning,
  white100: theme.ColorLightWhite100,
  white80: theme.ColorLightWhite80,
  white60: theme.ColorLightWhite60,
};

const lightTheme = {
  breakpoints,
  colors: lightColors,
  mode: 'light',
};

function ThemeProvider({ children }) {
  return (
    <StyledThemeProvider theme={lightTheme}>
      {children}
    </StyledThemeProvider>
  );
}

ThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ThemeProvider;
